import { FC } from 'react';

import { Checkbox } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { WeekendValue } from '../../model';
import { RetailsTestID } from '../../test-ids';
import { FieldLabel, FieldWrapper } from '../Retails.styles';
import { useRetailsContext } from '../RetailsContext';
import { WeekendFilterWrapper } from './WeekendFilter.styles';

export const WeekendFilter: FC = () => {
    const { t } = useTranslations();

    const { updateWeekendFilter, isHiddenFromScreenReader } = useRetailsContext();

    const handleInput = (isChecked: boolean, day: WeekendValue) => {
        updateWeekendFilter(day, isChecked);
    };

    return (
        <FieldWrapper data-test={RetailsTestID.WEEKEND_FILTER}>
            <FieldLabel tag="h2" variant="title-100">
                {t['retails_map.weekend.label']}
            </FieldLabel>
            <WeekendFilterWrapper>
                <Checkbox
                    id="retails-weekend-saturday"
                    onChange={(isChecked) => handleInput(isChecked as boolean, 'saturday')}
                    data-test={RetailsTestID.WEEKEND_SATURDAY}
                    disabled={isHiddenFromScreenReader}
                    label={t['retails_map.weekend.saturday']}
                />
                <Checkbox
                    id="retails-weekend-sunday"
                    onChange={(isChecked) => handleInput(isChecked as boolean, 'sunday')}
                    data-test={RetailsTestID.WEEKEND_SUNDAY}
                    disabled={isHiddenFromScreenReader}
                    label={t['retails_map.weekend.sunday']}
                />
            </WeekendFilterWrapper>
        </FieldWrapper>
    );
};
